import styled, { keyframes } from "styled-components";

const Animated = styled.span``;

const dotAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

Animated.Dot = styled.span`
  &.first {
    animation: 1.8s ${dotAnimation} linear;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-delay: 1.2s;
  }
  &.second {
    animation-delay: 0.8s;
    animation: 1.8s ${dotAnimation} linear;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
  &.third {
    animation: 1.8s ${dotAnimation} linear;
    animation-iteration-count: infinite;
    animation-timing-function: ease-in-out;
    animation-delay: 0.4s;
  }
`;

export { Animated };
